import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/aboutme/")({
	beforeLoad: () => {
		throw redirect({ to: "/aboutme/$tab", params: { tab: "profile" } });
	},
});
